import * as React from 'react';
import { Flex, FlexDirection } from 'src/components/Flex/Flex';
import { Color, CORNER_RATIO } from 'src/components/Globals/Globals';
import styled from 'styled-components';

const FOOTER_HEIGHT = 50;

const FooterBackground = styled(Flex)`
  background: ${Color.black};
  color: ${Color.white};
  padding-left: 20px;
  align-items: center;
`;

const FooterPrivacyStatement = styled(Flex)`
  background: ${Color.black};
  color: ${Color.white};
  padding-left: 20px;
  align-items: center;

  a {
    white-space: nowrap;
    color: ${Color.white};
    margin-right: 20px;
    text-decoration: none;
  }

  a:hover {
    text-decoration: underline;
  }

  &:before {
    content: '';
    top: 0px;
    left: 100%;
    position: relative;
    border-top: calc(0.75 * ${FOOTER_HEIGHT}px) solid ${Color.white};
    border-left: calc(0.75 * ${FOOTER_HEIGHT}px * ${CORNER_RATIO}) solid ${Color.black};
    width: 0;
    z-index: 0;
  }
`;

const privacyStatementAddress = `https://wartsila.sharepoint.com/sites/compass/Pages/Privacy-Notice.aspx`;

export class Footer extends React.Component {
  public render() {
    return (
      <Flex
        direction={FlexDirection.column}
        style={{ bottom: 0, minHeight: FOOTER_HEIGHT, flexShrink: 0, flexGrow: 0 }}
      >
        <Flex flexSize={6} style={{ flexGrow: 0 }}>
          <FooterBackground flexSize={10}>Copyright © Wärtsilä Corporation</FooterBackground>
          <FooterPrivacyStatement>
            <a href={privacyStatementAddress}>Privacy statement</a>
          </FooterPrivacyStatement>
          <Flex flexSize={2} />
        </Flex>
        <Flex flexSize={2} style={{ background: Color.black, height: '100%' }} />
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.tsx